import img1 from "./IMG_0549.jpg";
import img2 from "./IMG_0774.jpg";
import img3 from "./IMG_0874.jpg";
import img4 from "./IMG_8722.jpg";
import img5 from "./IMG_3144_polarr.JPEG";
import img6 from "./personal-pic.jpg";

const aboutPics = [img6, img1, img2, img5, img4, img3];

export default aboutPics;
